
    export default {
        name: "the-salon-item",
        props: {
            salon: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {};
        },
        computed: {
          isBetweenOpeningHours(){
            var today = new Date()
            var startTime = this.setDateTime(new Date(), this.salon.openingHours.find(h => h.day === today.getDay()).from + ':00').getTime()
            var closeTime = this.setDateTime(new Date(), this.salon.openingHours.find(h => h.day === today.getDay()).to + ':00').getTime()
            return today.getTime() > startTime && today.getTime() < closeTime
          },
          closedException() {
            const today = new Date();
            const currentDate = today.toISOString().split('T')[0];
            const exceptionToday = this.salon.openingHoursExceptions.find(ex => ex.date.split('T')[0] === currentDate && !ex.isOpen && !ex.deleted);

            if (exceptionToday) {
              return true
            } else return false
          },
          openingException() {
            const today = new Date();
            const currentDate = today.toISOString().split('T')[0];
            const currentTime = today.getHours() * 60 + today.getMinutes();
            const exceptionToday = this.salon.openingHoursExceptions.find(ex => ex.date.split('T')[0] === currentDate && ex.isOpen && !ex.deleted);

            if (exceptionToday) {
              const [fromHours, fromMinutes] = exceptionToday.from.split(':').map(Number);
              const [toHours, toMinutes] = exceptionToday.to.split(':').map(Number);

              const fromTime = fromHours * 60 + fromMinutes;
              const toTime = toHours * 60 + toMinutes;
              const isOpenNow = currentTime >= fromTime && currentTime <= toTime;

              return {
                isOpenByException: isOpenNow,
                from: exceptionToday.from,
                to: exceptionToday.to,
              };
            }

            return {
              isOpenByException: false,
              from: null,
              to: null,
            };
          },
          
          getTodaysHours(){
            var today = new Date().getDay()
            return today != 0 ? this.salon.openingHours.find(h => h.day === today) : this.salon.openingHours.find(h => h.day === 7)
          },
          salonImage() {
            var sites = this.$store.getters['cmsConfigHomepage/getSites']
            var salon = sites.filter(x => x.siteId == this.salon.siteId)[0]
            var imageUrl = salon.salonImageUrl;
            if (imageUrl && imageUrl != undefined && imageUrl != null) {
              return imageUrl
            } else {
              return 'https://res.cloudinary.com/odin-systemer-test/image/upload/v1504878858/defaults/d_missing_image.png'
            }
          }
        },
        methods: {
          navigateToUrl() {
            this.$router.push(`/about/${this.salon.urlFrendlyLink}`);
          },
          setDateTime(date, str){
            var sp = str.split(':');
            date.setHours(parseInt(sp[0],10));
            date.setMinutes(parseInt(sp[1],10));
            date.setSeconds(parseInt(sp[2],10));
            return date;
          },
          salonDistance(distance) {
            if (distance != null && distance != undefined && distance != NaN && distance != 0 && distance != '') {
              if (distance < 1) {
                return Math.round(distance*1000) + ' meter unna';
              } else if (distance >= 1 && distance <= 100) {
                return distance.toFixed(1) + ' kilometer unna';
              } else if (distance > 100) {
                return Math.round(distance) + ' kilometer unna';
              }
            } else {
              return ''
            }
          },
        },
    };
